"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBanner = exports.Header = exports.Label = exports.Text = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const Banners_1 = require("../../Banners");
exports.Text = styled_1.default.div `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.Label = (0, styled_1.default)(exports.Text) `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.Header = styled_1.default.h4 `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.InfoBanner = (0, styled_1.default)(Banners_1.InfoBanner) `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
`;
//# sourceMappingURL=styles.js.map